import { Injectable } from '@angular/core';
import { InsuranceCustomerDto } from '../dto/insurance/insurance-customer.dto';
import { UpdateCustomerRequest } from '../dto/insurance/update-customer-request.dto';
import { InsuranceCustomer } from '../model/insurance/insurance-customer.model';
import { BaseMapper } from './base-mapper';

@Injectable({
    providedIn: 'root',
})
export class InsuranceCustomerMapper extends BaseMapper<InsuranceCustomerDto, InsuranceCustomer> {
    public mapDtoToModel(dto: InsuranceCustomerDto): InsuranceCustomer {
        return {
            id: dto.id,
            externalId: dto.externalId,
            firstName: dto.firstName,
            lastName: dto.lastName,
            birthDate: dto.birthDate,
            email: dto.email,
            phoneNumber: dto.phoneNumber,
            authUserId: dto.authUserId,
            enabled: dto.enabled,
            createdAt: dto.createdAt,
            updatedAt: dto.updatedAt,
            uniqueMasterCitizenNumber: dto.uniqueMasterCitizenNumber,
            hasUniqueMasterCitizenNumber: dto.hasUniqueMasterCitizenNumber,
            thirdPartyData: {
                isBlocked: dto.thirdPartyData?.isBlocked,
                address: dto.thirdPartyData?.address,
                postCode: dto.thirdPartyData?.postCode,
                city: dto.thirdPartyData?.city,
                country: dto.thirdPartyData?.country,
            },
        };
    }

    public mapModelToUpdateRequest(model: InsuranceCustomer): UpdateCustomerRequest {
        return {
            firstName: model.firstName,
            lastName: model.lastName,
            dateOfBirth: model.birthDate,
            address: model.thirdPartyData?.address ?? null,
            postCode: model.thirdPartyData?.postCode ?? null,
            city: model.thirdPartyData?.city ?? null,
            country: model.thirdPartyData?.country ?? null,
            uniqueMasterCitizenNumber: model.uniqueMasterCitizenNumber ?? null,
        };
    }
}
